/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { useState, useEffect } from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
// import classNames from 'classnames'

// material UI
// import Grid from '@material-ui/core/Grid'
// import Typography from '@material-ui/core/Typography'
// import Paper from '@material-ui/core/Paper'
// import Box from '@material-ui/core/Box'
// import Button from '@material-ui/core/Button'
// import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import Fade from '@material-ui/core/Fade'
import Fab from '@material-ui/core/Fab'

// material ui icon
// import GetAppIcon from '@material-ui/icons/GetApp'

// my components
import withCompWidth from 'commonHoc/withCompWidth'
// import UserComponentName from 'components/molecules/UserComponentName'

// my containers
// import UserContainerName from 'containers/UserContainerName'
// import CommonButton from 'containers/CommonButtonContainer'

// libraries
// import getComponentId from 'lib/getComponentId'
// import config from 'config'
// import { isArray } from 'lib/detectType'
// import isEqualProps from 'lib/isEqualProps'
// import {
//   makeStyleObject as ms,
//   getClassName as cn,
//   getComponentByBreakpoint as gc
// } from 'lib/getBreakPoints'

export const useProps = {
  //  testVar: { default: 'hello world!', type: 'string.isRequired' }
}
/**
 * (작성된 설명이 없습니다.)
 */
const setTimer = fn => {
  setTimeout(() => {
    fn()
  }, 5000)
}
const CircularRequestProgress = ({ classes: cls, ...props }) => {
  const { visibleProgress, requestLoadingCountValue } = props
  const [visible, setVisible] = useState(visibleProgress)
  useEffect(() => {
    if (visibleProgress === true) {
      setTimer(() => {
        setVisible(false)
      })
    }
    setVisible(visibleProgress)
  }, [visibleProgress])
  return (
    <Fade
      in={visible}
      timeout={300}
      style={{
        zIndex: 2300,
        position: 'fixed',
        bottom: '50%',
        right: '50%',
        transform: 'translate(50%, 50%)'
      }}
    >
      <Fab disabled={true}>
        <CircularProgress
          color="primary"
          size={30}
          value={requestLoadingCountValue}
        />
      </Fab>
    </Fade>
  )
}

CircularRequestProgress.defaultProps = setDefaultProps(useProps)
CircularRequestProgress.propTypes = setPropTypes(useProps)
const commonStyles = theme => ({
  root: {}
})
export default React.memo(
  withStyles(commonStyles)(
    withCompWidth(CircularRequestProgress, { enabled: false })
  ),
  (prevProps, nextProps) => {
    return nextProps.visibleProgress === prevProps.visibleProgress
  }
)
